// extracted by mini-css-extract-plugin
export default {"rating":"TA-z","numberOfStars":"UA-z","count":"VA-z","barGraphSpacing":"WA-z","barGraph":"XA-z"};